export default __webpack_public_path__ + "images/grey-pin-large.png?8f1aed06367b6bd8d1f7b889736a2c6b";